import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import usePeriodicReviews from '../../../../hooks/usePeriodcReviews';
import type { Asset } from '../../../../models/asset';
import Checkups from '../../../periodicReviews/components/checkups';
import '../../../periodicReviews/styles.scss';
import type { MonitoringPersona } from '../../personaConfig';
import './ReviewsTab.scss';

interface IReviewsTabProps {
    asset: Asset | null;
    loading: boolean;
    userRole: MonitoringPersona;
}

const ReviewsTab = ({ asset, loading, userRole }: IReviewsTabProps) => {
    const intl = useIntl();
    const [hiddenIds, setHiddenIds] = useState<Set<string>>(new Set());

    const scheduleIds = useMemo(
        () =>
            [
                ...(asset?.schedulings?.next?.map(review => review.id) ?? []),
                ...(asset?.schedulings?.previous?.map(review => review.id) ?? []),
            ].filter(Boolean),
        [asset]
    );

    const { blockchainData, loading: bookLoading } = usePeriodicReviews({
        chassis: asset?.chassis ?? '',
        scheduleIds,
        userRole,
        dialog: !!asset,
    });

    if (loading && !asset) {
        return (
            <div className='fm-progress'>
                <i />
            </div>
        );
    }

    return (
        <div className='right-sidebar fm-embedded-book'>
            {hiddenIds.size > 0 && (
                <div className='fm-hidden-reviews'>
                    <span className='fm-muted'>
                        {intl.formatMessage({ id: 'intl-msg:periodicReviews.periodicReviews.hiddenReviews' })}
                    </span>
                    {[...hiddenIds].map(name => (
                        <button
                            key={name}
                            type='button'
                            className='fm-pillbtn'
                            onClick={() =>
                                setHiddenIds(prev => {
                                    const next = new Set(prev);
                                    next.delete(name);
                                    return next;
                                })
                            }
                        >
                            {name} <span className='rioglyph rioglyph-eye' />
                        </button>
                    ))}
                </div>
            )}
            <Checkups
                asset={asset}
                blockchainData={blockchainData}
                loading={bookLoading}
                isEnhanced={true}
                userRole={userRole}
                hiddenIds={hiddenIds}
                setHiddenIds={setHiddenIds}
            />
        </div>
    );
};

export default ReviewsTab;
